import {
  hasRefreshToken,
  isAuthenticated,
  refreshTokens,
  startLogin,
} from "@/lib/auth";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app")({
  beforeLoad: async () => {
    if (import.meta.env.VITE_STAGE === "local") {
      return;
    }

    if (isAuthenticated()) {
      return;
    }

    // refresh_token があれば復元を待たずに描画へ進み、永続化キャッシュを先に表示する。
    // API 呼び出しは restoreIdToken で復元完了を待つ。
    // 通信できなかっただけ（unreachable）ならログインへ飛ばず、キャッシュ表示を残す。
    if (hasRefreshToken()) {
      void refreshTokens().then((result) => {
        if (result === "rejected") {
          void startLogin();
        }
      });
      return;
    }

    await startLogin();
  },
  component: AppLayout,
});

function AppLayout() {
  return <Outlet />;
}
